import {
  createStyles,
  Badge,
  Group,
  Title,
  Text,
  Card,
  SimpleGrid,
  Container,
  Accordion,
} from '@mantine/core';
import { IconTools, IconTrash, IconTruckDelivery } from '@tabler/icons-react';

const mockdata = [
  {
    title: 'Site Services',
    description:
      'Site Services',
    icon: IconTools,
    list: <>
            <Accordion.Item value="Site/Equipment Decommissioning">
              <Accordion.Control>
              <Text size="lg" span>Site & Equipment Shutdown</Text>
              </Accordion.Control>
              <Accordion.Panel><Text align='center'>Our associated crews can handle the largest of projects from contaminated water to cyanide plant closures.</Text></Accordion.Panel>
            </Accordion.Item>

            <Accordion.Item value="Spill Response">
              <Accordion.Control>
              <Text size="lg">Spill Response</Text>
              </Accordion.Control>
              <Accordion.Panel><Text align='center'>In addition to our crew, we have access to first responders in many parts of Southern Ontario. </Text></Accordion.Panel>
            </Accordion.Item>

            <Accordion.Item value="Labpacks">
              <Accordion.Control>
              <Text size="lg">Labpacks</Text>
              </Accordion.Control>
              <Accordion.Panel><Text align='center'>Our technicians will separate and labpack all your miscellaneous laboratory and off-spec chemicals for safe transportation to a disposal facility.</Text></Accordion.Panel>
            </Accordion.Item>
          </>   
  },
  {
    title: 'Disposal',
    description:
      'Disposal',
    icon: IconTrash,
    list: <>
            <Accordion.Item value="Product Destruction">
              <Accordion.Control>
                <Text size="lg">Product Destruction</Text>
              </Accordion.Control>
              <Accordion.Panel><Text align='center'>We offer both incineration and shredding for secure product disposal. </Text></Accordion.Panel>
            </Accordion.Item>       

            <Accordion.Item value="Recycling">
              <Accordion.Control>
                <Text size="lg">Recycling</Text>
              </Accordion.Control>
              <Accordion.Panel><Text align='center'>We have various outlets for scrap metal, solvent and other recyclable materials.</Text></Accordion.Panel>
            </Accordion.Item> 

            <Accordion.Item value="Drums">
              <Accordion.Control>
                <Text size="lg">Liquid or Solid waste</Text>
              </Accordion.Control>
              <Accordion.Panel><Text align='center'>Whether you have small or large quantities of liquid or solid waste, we will find the right destination for final disposal.</Text></Accordion.Panel>
            </Accordion.Item>
          </>
  },
  {
    title: 'Transport',
    description:
      'Transport',
    icon: IconTruckDelivery,
    list: <>
            <Accordion.Item value="Small Quantities">
              <Accordion.Control>
                <Text size="lg">Small Quantities</Text>
              </Accordion.Control>
              <Accordion.Panel><Text align='center'>Under 10 drums.</Text></Accordion.Panel>
            </Accordion.Item>

            <Accordion.Item value="Medium Quantities">
              <Accordion.Control>
                <Text size="lg">Medium Quantities</Text>
              </Accordion.Control>
              <Accordion.Panel><Text align='center'>Up to 40 drums.</Text></Accordion.Panel>
            </Accordion.Item>

            <Accordion.Item value="Large Quantities">
              <Accordion.Control>
                <Text size="lg">Large Quantities</Text>
              </Accordion.Control>
              <Accordion.Panel><Text align='center'>Up to 80 Drums or 22 Skids.</Text></Accordion.Panel>
            </Accordion.Item>
          </>    
  },
];

const useStyles = createStyles((theme) => ({
  title: {
    fontSize: 34,
    fontWeight: 900,
    [theme.fn.smallerThan('sm')]: {
      fontSize: 24,
    },
  },
  hero: {
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  description: {
    maxWidth: 600,
    margin: 'auto',

    '&::after': {
      content: '""',
      display: 'block',
      backgroundColor: theme.fn.primaryColor(),
      width: 45,
      height: 2,
      marginTop: theme.spacing.sm,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },

  card: {
    border: `1px solid ${
      theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[1]
    }`,
  },

  cardTitle: {
    '&::after': {
      content: '""',
      display: 'block',
      backgroundColor: theme.fn.primaryColor(),
      width: 80,
      height: 2,
      marginTop: theme.spacing.sm,
    },
  },
}));

export default function Home() {
  const { classes, theme } = useStyles();
  const features = mockdata.map((feature) => (
    <Card key={feature.title} shadow="md" radius="md" className={classes.card} p="lg">
      <feature.icon size={50} strokeWidth={2} color={theme.fn.primaryColor()} />
      <Text size="xl" weight={500} className={classes.cardTitle}>
        {feature.title}
      </Text>
      <Accordion variant="filled" chevronPosition="left">
        {feature.list}  
      </Accordion>
    </Card>
  ));
  return (
    <div className={classes.hero}>
    <Container size="lg" py="xl">

      <Title order={2} className={classes.title} align="center" mt="md">
      Your resource for hazardous waste management.
      </Title>

      <Group position="center" mt="xs">
        <Badge color="tractor-green" variant="filled" size="xl">
          Services we offer
        </Badge>
      </Group>

      <SimpleGrid cols={3} spacing="xl" mt={50} breakpoints={[{ maxWidth: 'md', cols: 1 }]}>
        {features}
      </SimpleGrid>
    </Container>
    </div>
  );
}